export default defineAppConfig({
  ui: {
    primary: "indigo",
    gray: "cool",
    button: {
      default: {
        size: "md",
      },
      color: {
        primary: {
          solid: "shadow-sm border-0 text-white bg-primary-600 hover:bg-primary-500 disabled:bg-primary-400 aria-disabled:bg-primary-400 dark:bg-primary-800 dark:hover:bg-primary-700/50 dark:disabled:bg-primary-800 dark:aria-disabled:bg-primary-800 focus-visible:ring-2 focus-visible:ring-primary-600 dark:focus-visible:ring-primary-400",
          ghost: "text-primary-700 dark:text-primary-200 hover:text-primary-900 dark:hover:text-white hover:bg-primary-50 dark:hover:bg-primary-800 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400",
          link: "text-primary-500 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-200 underline-offset-4 hover:underline focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400",
        },
      },
      rounded: "rounded-lg",
    },
    input: {
      default: {
        size: "md",
      },
    },
    select: {
      default: {
        size: "md",
      },
    },
    formGroup: {
      default: {
        size: "md",
      },
    },
    notifications: {
      // Show toasts at the top right of the screen
      position: "top-0 bottom-[unset]",
    },
  },
  // ui: {
  //   primary: "sky",
  //   gray: "cool",
  //   variables: {
  //     light: {
  //       background: "var(--color-gray-50)",
  //     },
  //     dark: {
  //       background: "var(--color-gray-950)",
  //     },
  //   },
  //   header: {
  //     wrapper: "lg:!border-transparent bg-gray-50 dark:bg-gray-950",
  //     links: {
  //       wrapper: "ring-1 ring-gray-200 dark:ring-gray-800 px-3 gap-x-0 rounded-full",
  //       base: "py-2 px-4 font-medium transition-colors relative after:absolute after:-bottom-px after:inset-x-2 after:h-px after:rounded-full after:opacity-0 after:bg-gray-900 dark:after:bg-white after:transition-opacity",
  //       active: "text-gray-900 dark:text-white after:opacity-100",
  //       inactive: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200",
  //     },
  //   },
  //   footer: {
  //     top: {
  //       wrapper: "border-t border-gray-200 dark:border-gray-800",
  //       container: "py-8 lg:py-16",
  //     },
  //     bottom: {
  //       wrapper: "border-t border-gray-200 dark:border-gray-800",
  //     },
  //   },
  //   pricing: {
  //     card: {
  //       highlight: "ring-gray-900 dark:ring-white",
  //       features: {
  //         item: {
  //           icon: {
  //             base: "text-gray-900 dark:text-white",
  //           },
  //         },
  //       },
  //     },
  //   },
  // },
});
